import { TApiSortsReq } from "@/types/api";
import { RENEW_VISA_DOCUMENT_STATUS, TRenewVisaDocumentStatus } from "@/types/enum";

export type TRenewVisaListWithFilter = {
  status?: TRenewVisaDocumentStatus[];
  sorts?: TApiSortsReq[];
};

export const RENEW_VISA_FILTER: {
  NOT_CREATED_AND_IN_PROGRESS: TRenewVisaListWithFilter;
  UNDER_REVIEW_AND_APPROVED: TRenewVisaListWithFilter;
  COMPLETE_AND_WITHDRAWN_AND_REJECTED: TRenewVisaListWithFilter;
} = {
  NOT_CREATED_AND_IN_PROGRESS: {
    status: [RENEW_VISA_DOCUMENT_STATUS.NOT_CREATED, RENEW_VISA_DOCUMENT_STATUS.IN_PROGRESS],
    sorts: ["renewVisaDocument.residenceExpiryDate|ASC", "renewVisaDocument.id|DESC"],
  },
  UNDER_REVIEW_AND_APPROVED: {
    status: [RENEW_VISA_DOCUMENT_STATUS.UNDER_REVIEW, RENEW_VISA_DOCUMENT_STATUS.APPROVED],
    sorts: ["renewVisaDocument.applicationDate|DESC", "renewVisaDocument.id|DESC"],
  },
  COMPLETE_AND_WITHDRAWN_AND_REJECTED: {
    status: [RENEW_VISA_DOCUMENT_STATUS.COMPLETE, RENEW_VISA_DOCUMENT_STATUS.WITHDRAWN, RENEW_VISA_DOCUMENT_STATUS.REJECTED],
    sorts: ["renewVisaDocument.updatedAt|DESC", "renewVisaDocument.id|DESC"],
  },
};
